<template>
  <el-container class="app-container">
    <el-aside width="200px" class="aside">
      <div class="logo-container">
        <img src="@/assets/logo.png" alt="Logo" class="logo" />
        <span class="logo-text">退费平台</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        mode="vertical"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <el-menu-item
          v-for="item in menuItems"
          :key="item.name"
          :index="item.path || item.name"
          @click="handleMenuClick(item)"
        >
          <span>{{ item.name }}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container class="main-container">
      <el-header class="header">
        <span class="header-title">{{ currentTitle }}</span>
      </el-header>
      <el-main :class="['main', { 'no-scrollbar': currentExternalUrl }]">
        <router-view v-if="!currentExternalUrl" />
        <iframe
          v-else
          :src="currentExternalUrl"
          class="external-iframe"
          frameborder="0"
        />
      </el-main>
    </el-container>
  </el-container>
</template>

<script lang="ts" setup name="AppLayout">
import {computed, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {menuItems, MenuItem} from './layout_data';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

const route = useRoute();
const router = useRouter();

const currentExternalUrl = ref<string | null>(null);

const activeMenu = computed(() => {
    return route.path || '/';
});

const currentTitle = computed(() => {
    const item = menuItems.find(i => i.path === route.path || (i.isExternal && i.externalUrl === currentExternalUrl.value));
    return item?.name || '首页';
});

const getIcon = (iconName: string) => {
    return (ElementPlusIconsVue as any)[iconName] || ElementPlusIconsVue.Menu;
};

const handleMenuClick = (item: MenuItem) => {
    if (item.isExternal && item.externalUrl) {
        currentExternalUrl.value = item.externalUrl;
    } else if (item.path) {
        currentExternalUrl.value = null;
        router.push(item.path);
    }
};
</script>

<style scoped>
.app-container {
    height: 100vh;
    display: flex;
}

.aside {
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #304156;
    z-index: 100;
}

.main-container {
    flex: 1;
    margin-left: 200px;
    display: flex;
    flex-direction: column;
}

.logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    background-color: #2b3a4a;
    padding: 10px;
    border-bottom: 1px solid #1f2d3d;
}

.logo {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    margin-right: 10px;
}

.logo-text {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
}

.el-menu {
    border-right: none;
    height: calc(100vh - 60px);
}

.header {
    display: flex;
    align-items: center;
    padding: 0 20px;
    background-color: #fff;
    border-bottom: 1px solid #e4e7ed;
    flex-shrink: 0;
}

.header-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
}

.main {
    padding: 20px;
    background-color: #f5f7fa;
    overflow-y: auto;
    flex: 1;
}

.main.no-scrollbar {
    overflow: hidden;
    padding: 0;
}

.external-iframe {
    width: 100%;
    height: 100%;
    border-radius: 8px;
}
</style>
